import { useEffect, useRef } from "react";

/**
 * useReveal - attaches IntersectionObserver to children with `.reveal` class.
 * Adds `is-visible` once they enter viewport.
 */
export default function useReveal() {
  const root = useRef(null);

  useEffect(() => {
    const el = root.current || document;
    const targets = el.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((t) => t.classList.add("is-visible"));
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    targets.forEach((t) => obs.observe(t));
    return () => obs.disconnect();
  }, []);

  return root;
}
